import DatePicker from "react-datepicker";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/solid";
import React, { FC, Fragment, useState, useRef, useMemo, useEffect } from "react";
import DatePickerCustomHeaderTwoMonth from "../DatePickerCustomHeaderTwoMonth";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import NcInputNumber from "components/NcInputNumber/NcInputNumber";
import { useBooking } from "context/BookingContext";
import { addDays, } from "date-fns";
import { useClient } from "ClientContext";
import { useListingBooking } from "context/availabilitiesContext";
import { useFetchQuote } from "hooks/useFetchQuote";
import DatePickerCustomDay from "components/DatePickerCustomDay";

//transalation
import { useTranslation } from "react-i18next";


interface MobileCalendarQuoteProps {
  arrival: string | null;
  departure: string | null;
  setIsQuote?: (isQuote: boolean) => void;
  handleFetchQuote?: ({ listingId }: { listingId: string }) => void;
  renderChildren?: (p: { openModal: () => void }) => React.ReactNode;
}

const TODAY = new Date();
TODAY.setHours(0, 0, 0, 0);
const MIN_BOOKABLE_DAYS = 30;

const MobileCalendarWMinDays: FC<MobileCalendarQuoteProps> = ({
  renderChildren,
  setIsQuote,
  handleFetchQuote
}) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const { global_searh, global_max_guests } = useClient();
  const { bookingState, setBookingState } = useBooking();
  const { availabilitiesState } = useListingBooking();
  const dates = availabilitiesState.availabilities;


  const [guestCount, setGuestCount] = useState<number>(
    global_searh.params.guestsCount || 1
  );

  const { listingId } = bookingState;
  const { quoteError } = useFetchQuote();

  const max_guests = global_max_guests > 1 ? global_max_guests : 25;



  // State to control which month the calendar should show
  const [navDate, setNavDate] = useState<Date>(TODAY);

  // Parse date-only strings to local-midnight Date objects
  const excludedDates: Date[] = useMemo(
    () =>
      (dates || []).map((dateStr) => {
        const [year, month, day] = dateStr.split("-").map(Number);
        return new Date(year, month - 1, day);
      }),
    [dates]
  );

    // Track initial render
  const isInitialMount = useRef(true);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);


  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      setStartDate(null);
      setEndDate(null);
      setNavDate(TODAY);
      setBookingState((prev) => ({
        ...prev,
        searchParams: { ...prev.searchParams, checkIn: null, checkOut: null },
      }));
    }
  }, [setBookingState]);



  const onChangeDate = (datesRange: [Date | null, Date | null]) => {
    const [clickedDate, clickedEnd] = datesRange;

    // 1) If both start and end are set and user clicks a date
    if (startDate && endDate && clickedDate && !clickedEnd) {
      // Changing end only
      if (clickedDate > endDate) {
        setEndDate(clickedDate);
        setBookingState((prev) => ({
          ...prev,
          searchParams: { ...prev.searchParams, checkIn: startDate, checkOut: clickedDate },
        }));
      } else {
        // Reset start and auto-calc end
        const newStart = clickedDate;
        const autoEnd = addDays(newStart, MIN_BOOKABLE_DAYS);
        setStartDate(newStart);
        setEndDate(autoEnd);
        setNavDate(newStart); // shift UI on start change
        setBookingState((prev) => ({
          ...prev,
          searchParams: { ...prev.searchParams, checkIn: newStart, checkOut: autoEnd },
        }));
      }
     // onDatesChange?.();
      return;
    }

    // 2) Full range selected initially
    if (clickedDate && clickedEnd) {
      // Always shift on initial start selection
      if (!startDate) setNavDate(clickedDate);
      let newStart = clickedDate;
      let newEnd = clickedEnd;
      if (newEnd < addDays(newStart, MIN_BOOKABLE_DAYS)) {
        newEnd = addDays(newStart, MIN_BOOKABLE_DAYS);
      }
      setStartDate(newStart);
      setEndDate(newEnd);
      setBookingState((prev) => ({
        ...prev,
        searchParams: { ...prev.searchParams, checkIn: newStart, checkOut: newEnd },
      }));
    //  onDatesChange?.();
      return;
    }

    // 3) First click (only start)
    if (clickedDate && !clickedEnd) {
      setNavDate(clickedDate);
      const autoEnd = addDays(clickedDate, MIN_BOOKABLE_DAYS);
      setStartDate(clickedDate);
      setEndDate(autoEnd);
      setBookingState((prev) => ({
        ...prev,
        searchParams: { ...prev.searchParams, checkIn: clickedDate, checkOut: autoEnd },
      }));
     // onDatesChange?.();
      return;
    }

    // 4) Clear selection
    setStartDate(null);
    setEndDate(null);
    setNavDate(TODAY); // reset calendar view to current + next month
    setBookingState((prev) => ({
      ...prev,
      searchParams: { ...prev.searchParams, checkIn: null, checkOut: null },
    }));
   // onDatesChange?.();
    setIsQuote && setIsQuote(false);
  };

  const onGuestCountChange = (value: number) => {
    setGuestCount(value);
    setBookingState((prevState) => ({
      ...prevState,
      searchParams: {
        ...prevState.searchParams,
        guests: value,
      },
    }));
  };

  const renderButtonOpenModal = () => {
    return renderChildren ? (
      renderChildren({ openModal: () => setShowModal(true) })
    ) : (
      <button onClick={() => setShowModal(true)}>Select Date</button>
    );
  };

  <div className="bg-black text-white p-4 rounded-md">
    {quoteError}
  </div>;
  if (!max_guests) {
    return null;
  }
  return (
    <>
      {renderButtonOpenModal()}
      <Transition appear show={showModal} as={Fragment}>
        <Dialog
          as="div"
          className="HeroSearchFormMobile__Dialog relative z-50"
          onClose={() => setShowModal(false)}
        >
          <div className="fixed inset-0 bg-neutral-100 dark:bg-neutral-900">
            <div className="flex h-full relative">
              <Transition.Child
                as={Fragment}
                enter="ease-out transition-transform"
                enterFrom="opacity-0 translate-y-52"
                enterTo="opacity-100 translate-y-0"
                leave="ease-in transition-transform"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-52"
              >
                <Dialog.Panel className="relative h-full overflow-hidden flex-1 flex flex-col justify-between">
                  {/* Close Button */}
                  <div className="absolute top-4 right-4 z-50">
                    <button
                      className="p-2 rounded-full bg-black dark:bg-neutral-800 shadow-md   dark:hover:bg-neutral-700 focus:outline-none"
                      onClick={() => setShowModal(false)}
                    >
                      <XMarkIcon className="w-4 h-4 text-white dark:text-white" />
                    </button>
                  </div>

                  {/* Guest Selector */}
                  <div className="p-5 mt-2 bg-white dark:bg-neutral-800">
                    <span className="block font-semibold text-lg mb-3">
                      {t("Select Dates and Guests")}
                    </span>
                    <div className="w-full">
                      <NcInputNumber
                        className="w-full"
                        defaultValue={guestCount}
                        onChange={onGuestCountChange}
                        max={max_guests}
                        label={t("Guests")}
                        desc={t("Number of people")}
                      />
                    </div>
                  </div>

                  {/* Date Picker */}
                  <div className="flex-1 pt-1 flex flex-col overflow-auto">
                    <div className="flex-1 flex flex-col bg-white dark:bg-neutral-800">
                      <div className="flex-1 flex flex-col overflow-auto p-5">
                        <span className="block font-semibold text-xl sm:text-2xl">
                          {t("When's your trip?")}
                        </span>
                        <div className="overflow-hidden rounded-3xl shadow-lg ring-1 ring-black ring-opacity-5 bg-white dark:bg-neutral-800 p-8">
                          <DatePicker
                            key={navDate.getTime()}           // force remount when navDate changes
                            minDate={TODAY}
                            selected={startDate ?? undefined}
                            onChange={onChangeDate}
                            startDate={startDate ?? undefined}
                            endDate={endDate ?? undefined}
                            selectsRange
                            monthsShown={2}
                            showPopperArrow={false}
                            inline
                            excludeDates={excludedDates}
                            openToDate={navDate}               // direct the UI to navDate
                            filterDate={(date) => {
                              if (startDate && !endDate) return date >= addDays(startDate, MIN_BOOKABLE_DAYS);
                              return true;
                            }}
                            renderCustomHeader={(props) => <DatePickerCustomHeaderTwoMonth {...props} />}
                            renderDayContents={(day, date) => <DatePickerCustomDay dayOfMonth={day} date={date} />}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Footer Buttons */}
                  <div className="px-4 py-3 bg-white dark:bg-neutral-900 border-t border-neutral-200 dark:border-neutral-700 flex justify-between">
                    <button
                      type="button"
                      className="underline font-semibold"
                      onClick={() => onChangeDate([null, null])}
                    >
                      {t("Clear dates")}
                    </button>
                    {startDate && endDate && (
                      <ButtonPrimary
                        sizeClass="px-6 py-3 !rounded-xl"
                        onClick={() => {
                          handleFetchQuote && handleFetchQuote({ listingId });
                          setShowModal(false); // Close the modal
                        }}
                      >
                        {t("Apply")}
                      </ButtonPrimary>
                    )}
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default MobileCalendarWMinDays;